<script setup lang="ts">
import { config } from "@/config";

const props = defineProps<{
  pdfNamePrefix: string;
}>();

const { language } = config.app;

const termLanguage = language === "da" ? "da" : "en";
</script>

<template>
  <iframe
    class="terms__pdf"
    :src="'https://d25jgir1i1391d.cloudfront.net/terms/' + props.pdfNamePrefix + termLanguage + '/index.html'"
    width="100%"
    height="1000"
  />
</template>

<style lang="less" scoped>
.terms__pdf {
  display: block;
  margin: 0 auto;
}

.terms__container {
  min-height: calc(100vh - 70px);
}
</style>
